export default {
  saveAccountSettings: {
    url: '/useradmin/:id/update_user/',
    options: {
      method: 'POST',
    },
  },
  updateUserPassword: {
    url: '/useradmin/:id/update_user_password/',
    options: {
      method: 'POST',
    },
  },
  createSubscription: {
    url: '/subscription/',
    options: {
      method: 'POST',
    },
  },
};
